
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicios",
      function () {
        return require("private-next-pages/servicios.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servicios"])
      });
    }
  